module.exports = __webpack_public_path__ + "img/Nazar Hussain.ac5d0ae7.jpg";